/** @jsx jsx */
/* eslint-disable no-use-before-define */
import React from 'react'
import { $, publish, fmt, Loading, Status, mediaQueries, show, cleanObject, Paging, hideModal } from '../../twd'
import { jsx } from '@emotion/core'
import { useManageSavedSearches, deleteSavedSearches } from './use-manage-saved-searches'

export default () => {

    const [saving, setSaving] = React.useState(false)
    const [page, setPage] = React.useState(1)
    const {rows, setRows, status} = useManageSavedSearches()

    let pageSize = 10
    let rowsNotDeleted = rows.filter(r => !r.deleted)
    let hasDeleted = rowsNotDeleted.length !== rows.length

    React.useEffect(() => {
        setTimeout(() => {
            $('#modal :focusable').eq(0).focus()
        }, 200)
    }, [status])

    return <React.Fragment>
    <div className="modal-dialog modal-md">
    <div className="modal-content">
        <div className="modal-header">
            <button
                data-name="saved-searches-manage-close"
                className="close"
                aria-label="close"
                type="button"
                onClick={hideModal}>
            <i className="material-icons" aria-hidden="true">close</i>
            </button>

            <h3 className="modal-title text-center vertical-offset-sm">Manage saved searches</h3>
            <div className="row form-group subhead">
            <div className="col-xs-12 col-md-12 table-responsive">
                <Loading status={status}>
                <table
                    data-name="saved-searches-manage-table"
                    className="table table-hover align-top"
                    css={tableCss}
                >
                    <thead>
                    <tr>
                    <th>Name</th>
                    <th>Last Modified</th>
                    <th style={{width:"65px"}}></th>
                    </tr>
                </thead>
                <tbody>
                    <List rows={rows} setRows={setRows} saving={saving} page={page} size={pageSize} />
                </tbody>
                </table>

                { (rowsNotDeleted.length > pageSize) &&
                <div className="text-center">
                    <Paging total={rowsNotDeleted.length} page={page} setPage={setPage} size={pageSize} />
                </div>
                }
                </Loading>
            </div>
            </div>
        </div>

        {status!==Status.LOADING &&
        <div className="modal-footer">
        <div className="row">
        <div className="col-centered-8">
            <button
                data-name="saved-searches-manage-save"
                className="btn btn-block btn-lg btn-primary"
                    type="button"
                disabled={saving || !hasDeleted}
                onClick={async () => {
                    setSaving(true)
                    let deletedIds = await deleteSavedSearches(rows)
                    hideModal()
                    publish('manage_saved_searches', {deletedIds})
                }}
            >Save</button>
            <button
                data-name="saved-searches-manage-cancel"
                className="btn btn-block btn-lg btn-link"
                type="button"
                onClick={hideModal}
            >Cancel</button>
        </div>
        </div>
        </div>}

    </div>
    </div>

    </React.Fragment>
}

const List = ({rows, setRows, saving, page=1, size=3} = {}) => {
    let n = Math.max((page-1) * size, 0)

    return rows
    .filter(r => !r.deleted)
    .slice(n, n + size)
    .map( (r,i) => {
        return <tr
            data-name="saved-searches-manage-row"
            key={i}
        >
            <td className="text-truncate text-bold">
                <Item row={r} />
            </td>
            <td>{fmt.date(r.modified)}</td>
            <td><button
                data-name="saved-searches-manage-delete"
                className="btn btn-sm btn-primary-outline"
                disabled={saving}
                onClick={() => {
                    r.deleted = true
                    setRows([].concat(rows))
                }}
            >Delete</button></td>
        </tr>
    })
}

const tableCss = {
    [mediaQueries.notXs]: {
        tableLayout: 'fixed',

        '& td': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }
}

const Item = ({row}) => {
    return (
    <button
        data-name="saved-searches-manage-item"
        className="btn-link"
        onClick={() => { onSearch(row) }}
    >
        {row.description}
    </button>
    )
}

const onSearch = ({searchParams}) => {
    hideModal()
    show('offerings', Object.assign({
        searchParams: cleanObject(searchParams),
        _ts: Date.now(),
        from: 'advanced-screener'
    }))
}



// WEBPACK FOOTER //
// ./src/saved-searches/manage-saved-searches/manage-saved-searches.js